import React from "react";
import styled from "styled-components";
import IconPayment from "../../assets/icons/IconPayment";
import { Modal } from "react-rainbow-components";
import { Image } from "react-bootstrap";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const ImageContainer = styled(Image)`
  width: 100%;
  object-fit: contain;
`;

const CheckRefPayment = (props: {
  refPayment: string | undefined;
  size?: string;
}) => {
  const [isOpenPayment, setIsOpenPayment] = React.useState(false);
  return (
    <Container onClick={() => setIsOpenPayment(!isOpenPayment)}>
      <IconPayment size={props.size} refPayment={props.refPayment} />
      {props.refPayment && (
        <Modal
          hideCloseButton
          isOpen={isOpenPayment}
          onRequestClose={() => setIsOpenPayment(!isOpenPayment)}
          size="small"
        >
          <ModalContainer>
            <ImageContainer src={props.refPayment} />
          </ModalContainer>
        </Modal>
      )}
    </Container>
  );
};

export default CheckRefPayment;
